import { all, fork } from 'redux-saga/effects';
import { watchTemplateVariableSaga } from './saga';

export function* variableTemplateRootSaga(): Generator {
  yield all([fork(watchTemplateVariableSaga)]);
}
